import React from 'react';
import Calendar from '../components/Calendar';

const CalendarPage = () => {
  return (
    <div className="page-container">
      <Calendar />
    </div>
  );
};

export default CalendarPage;